<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Transportation
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import { mapActions, mapMutations, mapState } from 'vuex';
import AnsButton from '@/components/ansButton/index.vue';
import messages from '@/utils/messages';
/**
 * Define component for popup Fab040120i
 */
var Transportation = {
    components: { AnsButton },
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    created() {
        this.onSearchItem();
    },
    data() {
        let isDefaultColorSettings = false;
        if (localStorage.getItem('mainColor') == null || localStorage.getItem('subColor') == null || localStorage.getItem('backColor') == null) {
            isDefaultColorSettings = true;
        }
        const mainColor = JSON.parse(localStorage.getItem('mainColor'));
        const subColor = JSON.parse(localStorage.getItem('subColor'));
        const backColor = JSON.parse(localStorage.getItem('backColor'));
        // check customer module or manager module
        let isManager = localStorage.getItem('mode') == 1 ? true : false;
        return {
            searchResult: [],
            searchParams: {
                item_code: '',
                item_name: '',
                page_size: 10,
                page_no: 1
            },
            msgNoData: '',
            paging: {},
            mainColor: mainColor,
            subColor: subColor,
            backColor: backColor,
            defaultColorSettings: isDefaultColorSettings,
            isManager: isManager
        };
    },
    emits: ['close'],
    computed: {
        ...mapState('MNG_System002_Detail', ['data'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapMutations('MNG_System002_Detail', ['updateItemTransportation']),
        ...mapActions('MNG_System002_Detail', ['searchItem']),
        onSearchItem() {
            this.search(this.searchParams);
        },
        search(data) {
            this.searchItem({
                body: {
                    ...data
                },
                callback: (response) => {
                    if (response.Data.data.length) {
                        this.searchResult = response.Data.data;
                        this.paging = response.Data.paging[0];
                        this.msgNoData = '';
                    } else {
                        this.msgNoData = '該当するデータが存在しません。';
                        this.searchResult = [];
                        this.paging = {};
                    }
                },
                onError: (errorMessage) => {
                    this.showHeaderError([errorMessage ?? messages.E999]);
                }
            });
        },
        changeCurrentPage(data) {
            this.search({
                ...this.searchParams,
                page_size: data.perPage,
                page_no: data.currentPage
            });
        },
        chooseItem(item) {
            this.updateItemTransportation({
                id: this.id,
                item_id: item.item_id,
                item_code: item.item_code,
                item_name: item.item_name
            });
            this.$emit('close');
        }
    }
};
export default Transportation;
</script>
<style lang="scss">
@import '@/assets/scss/common/popup.scss';
</style>
